/* ride.parts header: marks the bar as scrolled once the page leaves the top,
   so the background and the wordmark position can change. Horizon scrolls the
   page inside .page-wrapper, not the window, so scroll events are captured on
   the document and only ancestors of the header count. */
(function () {
  var header = document.querySelector('[data-ride-header]');
  if (!header) return;
  var ticking = false;
  function offset() {
    var y = window.scrollY || window.pageYOffset || 0;
    var el = header.parentElement;
    while (el && el !== document.body) {
      y += el.scrollTop || 0;
      el = el.parentElement;
    }
    return y;
  }
  var burger = header.querySelector('[data-ride-burger]');
  function setOpen(open) {
    header.classList.toggle('is-open', open);
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (burger) {
    burger.addEventListener('click', function () {
      setOpen(!header.classList.contains('is-open'));
    });
    // A tap on a link closes the menu.
    header.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('.ride-header__nav a')) setOpen(false);
    });
  }
  function update() {
    ticking = false;
    var scrolled = offset() > 4;
    header.classList.toggle('is-scrolled', scrolled);
    if (!scrolled) setOpen(false);
  }
  function onScroll(event) {
    var t = event.target;
    if (t !== document && t !== window && !(t.contains && t.contains(header))) return;
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  update();
})();
